/*
 * @Author: Teemo Ding
 * @Date: 2021-08-04 16:05:58
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-26 08:57:22
 * @FilePath: /unifyxp-v2-store-portal/src/config/routerConfig/CustomerDatabase/CustomerDatabase.ts
 */

import {
  CustomerDatabaseSettings,
  CustomerDatabaseTagEditor,
  CustomerDatabaseTagList,
  CustomerDetails,
  CustomerList,
} from '@/src/pages';
import { IRouteSubRoutes } from 'src/types/router';
// import { storeResourceNameGenerator } from 'src/tools/getUserInfo';
import {
  tagDetailPage,
  tagListPage,
  dbSettingPage,
  customerDetailPage,
  customerListPage,
} from '@/src/tools/permissions/storePermissions';
import {
  //EnumResources,

  EPermissionSource,
} from 'src/types/common/resources';
import { storeRoutes } from 'src/tools/urlMap';

const listRoutes: IRouteSubRoutes[] = [
  {
    exact: true,
    path: storeRoutes.customerList, // '/customerDatabase/customerList/:customerDatabaseUuid',
    component: CustomerList,
    isPrivate: true,
    permissionGroup: customerListPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.customerDetail, //'/customerDatabase/customerDetail/:customerDatabaseUuid/:customerUuid',
    component: CustomerDetails,
    isPrivate: true,
    permissionGroup: customerDetailPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.customerDatabaseSetting, // '/customerDatabase/databaseSettings/:customerDatabaseUuid',
    component: CustomerDatabaseSettings,
    isPrivate: true,
    permissionGroup: dbSettingPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.customerTagDetail, //'/customerDatabase/tagEdit/:customerDatabaseUuid/:tagUuid',
    component: CustomerDatabaseTagEditor,
    isPrivate: true,
    permissionGroup: tagDetailPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.customerTagList, // '/customerDatabase/tagList/:customerDatabaseUuid',
    component: CustomerDatabaseTagList,
    isPrivate: true,
    permissionGroup: tagListPage,
    source: EPermissionSource.store,
  },

  ,
];
export default listRoutes;
